import type { LeadFilters } from '../model/types'

export const leadKeys = {
  all: ['leads'] as const,
  // The whole slice is the key — window, filters and page alike. A different
  // slice is a different list, so switching one fetches instead of invalidating
  // what is already cached.
  list: (params: LeadFilters & { campaignId: string; page: number; pageSize: number }) =>
    [...leadKeys.all, 'list', params.campaignId, params] as const,
  detail: (id: string) => [...leadKeys.all, 'detail', id] as const,
}
